/* eslint-disable max-lines */
/* eslint-disable sort-keys */

export const headerStyles = {
    alignItems: 'center',
    backgroundColor: '$containerEmbedHeader',
    borderColor: '$containerEmbedHeaderBorder',
    borderBottomWidth: '$containerEmbedHeaderBorder',
    borderBottomStyle: '$containerEmbedHeaderBorder',
    boxSizing: 'border-box',
    display: 'flex',
    height: '$$headerHeight',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: '$containerHeader',
    padding: '$containerEmbedHeader',
    variants: {isEmbedHeroVisible: {true: {borderBottom: 'none'}}},
}

export const headerContent = {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    height: '100%',
    justifyContent: 'space-between',
    // padding: '10px',
    width: '100%',
    cursor: 'default',
    textDecoration: 'none',
}

export const buttonsWrapper = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    gap: '5px',
    variants: {
        variant: {
            center: {
                minWidth: 0,
                width: '100%',
                padding: '0 5px',
            },
        },
    },
}

export const centerButtonWrapper = {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    variants: {noLeftActions: {true: {justifyContent: 'flex-start'}}},
}


const buttonShared = {
    'alignItems': 'center',
    'backgroundColor': '$containerEmbedHeaderButtonBackground',
    'borderWidth': '$containerEmbedHeaderButton',
    'borderStyle': '$containerEmbedHeaderButton',
    'borderColor': '$containerEmbedHeaderButtonBorder',
    'borderRadius': '$containerEmbedHeaderButton',
    'boxSizing': 'border-box',
    'display': 'flex',
    'cursor': 'pointer',
    'justifyContent': 'center',
    'padding': '$containerEmbedHeaderButton',
    'height': '40px',
    'minHeight': '40px',
    'minWidth': '40px',
    '&:focus-visible': {outline: '2px solid $containerEmbedHeaderButtonActiveOutline'},
    '&:hover&:focus': {backgroundColor: '$containerEmbedHeaderButtonFocusBackground'},
    '> span.text:not(:empty):not(:only-child)': {marginLeft: '5px'},
}

export const embedButton = {
    ...buttonShared,
    'color': '$containerEmbedHeaderButton',
    'fontFamily': '$containerEmbedHeaderButton',
    'fontSize': '$containerEmbedHeaderButton',
    'fontWeight': '$containerEmbedHeaderButton',
    '&:hover': {
        backgroundColor: '$containerEmbedHeaderButtonHoverBackground',
        color: '$containerEmbedHeaderButtonHover',
        svg: {color: '$containerEmbedHeaderButtonIconHover'},
    },
    'svg': {color: '$containerEmbedHeaderButtonIcon'},
    'variants': {
        textLeft: {
            true: {
                '> span.text:not(:empty):not': {
                    marginLeft: '0',
                    marginRight: '5px',
                },
            },
        },
        variant: {
            close: {
                'color': '$containerEmbedHeaderCloseButton',
                'padding': '$containerEmbedHeaderCloseButton',
                'backgroundColor': '$containerEmbedHeaderCloseButtonBackground',
                'borderWidth': '$containerEmbedHeaderCloseButton',
                'borderStyle': '$containerEmbedHeaderCloseButton',
                'borderColor': '$containerEmbedHeaderCloseButtonBorder',
                'borderRadius': '$containerEmbedHeaderCloseButton',
                '&:focus-visible': {outline: '2px solid $containerEmbedHeaderCloseButtonActiveOutline'},
                '&:hover&:focus': {backgroundColor: '$containerEmbedHeaderCloseButtonFocusBackground'},
                '&:hover': {
                    backgroundColor: '$containerEmbedHeaderCloseButtonHoverBackground',
                    color: '$containerEmbedHeaderCloseButtonHover',
                    svg: {color: '$containerEmbedHeaderCloseButtonIconHover'},
                },
                'svg': {
                    color: '$containerEmbedHeaderCloseButtonIcon',
                    width: '25px',
                    height: '25px',
                },
            },
            dropdown: {
                svg: {
                    transform: 'rotate(90deg)',
                    width: '24px',
                    height: '24px',
                },
            },
            chatList: {
                svg: {
                    width: '19px',
                    height: '18px',
                },
            },
        },
    },
}

export const embedTitle = {
    'background': 'none',
    'border': 'none',
    'padding': '5px 10px',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'pointerEvents': 'none',
    'maxWidth': '100%',
    'minWidth': 0,
    'overflow': 'hidden',
    '> div': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '100%',
    },
    'variants': {
        noLeftActions: {
            true: {
                '> div': {
                    justifyContent: 'flex-start',
                    width: '100%',
                },
            },
        },
        activeButton: {
            true: {
                ...buttonShared,
                'width': '100%',
                'height': 'auto',
                'pointerEvents': 'all',
                'padding': '$containerEmbedHeaderTitleButton',
                'borderRadius': '$containerEmbedHeaderTitleButton',
                'backgroundColor': '$containerEmbedHeaderTitleButtonBackground',
                'borderWidth': '$containerEmbedHeaderTitleButton',
                'borderStyle': '$containerEmbedHeaderTitleButton',
                'borderColor': '$containerEmbedHeaderTitleButtonBorder',
                '[data-id="title"]': {color: '$containerEmbedHeaderTitleButtonTitle'},
                '[data-id="subtitle"]': {color: '$containerEmbedHeaderTitleButtonSubtitle'},
                '&:hover': {
                    'backgroundColor': '$containerEmbedHeaderTitleButtonHoverBackground',
                    '[data-id="title"]': {color: '$containerEmbedHeaderTitleButtonTitleHover'},
                    '[data-id="subtitle"]': {color: '$containerEmbedHeaderTitleButtonSubtitleHover'},
                },
                '&:focus-visible': {outline: '2px solid $containerEmbedHeaderTitleButtonActiveOutline'},
                '&:hover&:focus': {backgroundColor: '$containerEmbedHeaderTitleButtonFocusBackground'},

            },
        },
    },
}

export const titleWrapper = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
    flex: 1,
}

export const title = {
    color: '$containerEmbedHeaderTitle',
    fontFamily: '$containerEmbedHeaderTitle',
    fontSize: '$containerEmbedHeaderTitle',
    fontWeight: '$containerEmbedHeaderTitle',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
}

export const subtitle = {
    color: '$containerEmbedHeaderSubtitle',
    fontFamily: '$containerEmbedHeaderSubtitle',
    fontSize: '$containerEmbedHeaderSubtitle',
    fontWeight: '$containerEmbedHeaderSubtitle',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}

export const defaultHeaderImage = {
    maxHeight: '100%',
    height: '$$imageHeight',
    width: '$$imageWidth',
}

export const svgImageWrapper = {
    maxWidth: '100%',
    height: '$$imageHeight',
    width: '$$imageWidth',
}

export const imageWrapper = {
    color: '$containerEmbedHeaderIcon',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
    lineHeight: 0,
}

export const memberImages = {
    'display': 'flex',
    'justifyContent': 'center',
    'div[data-name="user-avatar"]': {
        'width': '$containerEmbedHeaderAvatar',
        'height': '$containerEmbedHeaderAvatar',
        '> img:first-child': {
            // profile image
            borderRadius: '40%',
        },
        '> div:first-child': {
            // letter avtar
            borderRadius: '40%',
            fontSize: '$containerEmbedHeaderAvatar',
            width: '$containerEmbedHeaderAvatar',
            height: '$containerEmbedHeaderAvatar',
            backgroundColor: '$containerEmbedHeaderAvatarBackground',
            borderColor: '$containerEmbedHeaderAvatarBorder',
            color: '$containerEmbedHeaderAvatar',
        },
    },
    '> div': {
        'marginLeft': '-10px',
        '&:first-child': {marginLeft: 0},
    },
}

export const channelAvatar = {
    'display': 'flex',
    'justifyContent': 'center',
    '> div': {
        borderColor: '$containerEmbedHeaderAvatarBorder',
        color: '$containerEmbedHeaderAvatar',
    },
    'marginBottom': '5px',
}

export const moreUsers = {
    backgroundColor: '$containerEmbedHeader',
    borderColor: '$containerEmbedHeaderAvatarBorder',
    borderWidth: '$avatar',
    borderStyle: 'solid',
    borderRadius: '$avatarBorder',
    color: '$containerEmbedHeaderAvatar',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '$avatar',
    height: '$avatar',
    position: 'relative',
}

export const buttonImageWrapper = {lineHeight: 0}

export const buttonSvgImageWrapper = {
    '&&': {
        svg: {
            width: '100%',
            height: '100%',
        },
    },
    'width': '$$width',
    'height': '$$height',
}

export const dropdown = {
    backgroundColor: '$dropdownBackground',
    border: '1px solid $dropdownBorder',
    borderRadius: '6px',
    boxShadow: '$dropdownShadow',
    padding: '8px',
    position: 'absolute',
    top: 'calc(100% - 5px)',
    minWidth: '200px',
    zIndex: '$headerDropdown',
    left: '$$left',
}

export const dropdownList = {
    listStyle: 'none',
    margin: 0,
    padding: 0,
}

export const dropdownItem = {marginBottom: '5px'}

export const dropdownItemButton = {
    'background': 'none',
    'border': 'none',
    'borderRadius': '6px',
    'color': '$buttonText',
    'width': '100%',
    'textAlign': 'left',
    'padding': '6px 12px',
    'cursor': 'pointer',
    'fontWeight': 600,
    'fontSize': '14px',
    'display': 'flex',
    'alignItems': 'center',
    'gap': '10px',
    '[data-id="switch"]': {
        'margin': 0,
        'gap': 0,
        'height': '18px',
        '> div': {
            margin: 0,
            gap: 0,
        },
        'input': {
            'cursor': 'pointer',
            'display': 'block',
            'width': '34px',
            'height': '18px',
            'borderRadius': '4px',
            '&:before': {
                width: '14px',
                height: '14px',
                top: '1px',
                left: '1px',
            },
            '+ svg': {
                width: '14px',
                height: '14px',
                right: '2px',
                top: '50%',
            },
            '&:checked': {
                '&::before': {
                    left: 'unset',
                    transform: 'translateX(18px)',
                },
                '+ svg': {left: '3px'},
            },
        },
    },
    '&:hover': {backgroundColor: '$dropdownItemBackgroundHover'},
    'variants': {name: {mute: {justifyContent: 'space-between'}}},
}


export const dropdownItemIcon = {
    width: '25px',
    height: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '100%',
        maxHeight: '100%',
    },
    variants: {
        name: {
            close: {
                svg: {
                    width: '25px',
                    height: '25px',
                },
            },
            chatList: {
                svg: {
                    width: '19px',
                    height: '18px',
                },
            },
        },
    },
}

export const dropdownItemSwitchWrapper = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '25px',
}
